import { Input, Button, Alert, Checkbox, Row, Col, Spin } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  confirmLogin,
  initiateGsisLogin,
  setRememberMe,
} from '../../../store/user/actions';
import { useNavigate, Link } from 'react-router-dom';
import { getSystemLocales } from 'store/forms/actions';
import { getLocalString, localNames } from 'utils/localisation.service';
import { Label, TextField, FormTitle, FormSwitcher } from 'components';
import isEmpty from 'lodash/isEmpty';
import Πολιτική_Cookies  from '../../../assets/documents/Πολιτική_Cookies.pdf';
import Πολιτική_Απορρήτου from '../../../assets/documents/Πολιτική_Απορρήτου.pdf';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { rememberMe } = useSelector(state => state.user);
  const [checked, setChecked] = useState(rememberMe);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locales = useSelector(state => state.forms?.localeStrings);
  const isLoadingLocales = useSelector(state => state.forms?.loadingLocales);
  const inputRef = useRef(null);
  const { hasError, hasInfo, loading, message, gsisAuthUrl } = useSelector(
    state => state.forms.appConfig
  );

  useEffect(() => {
    const storedLanguage =
      localStorage.getItem('appLanguage') ||
      process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
    dispatch(getSystemLocales(storedLanguage));
  }, [dispatch]);

  useEffect(() => {
    // Sync local checked state with Redux rememberMe state
    setChecked(rememberMe);
  }, [rememberMe]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const onRememberMeChange = e => {
    dispatch(setRememberMe(e.target.checked));
  };

  const authProviderSubmitClicked = () => {
    dispatch(initiateGsisLogin(gsisAuthUrl));
  };

  const logingcall = () => {
    const payload = {
      j_username: email,
      j_password: password,
      _spring_security_remember_me: checked,
      submit: 'login',
    };

    dispatch(
      confirmLogin(payload, navigate, (check, res) => {
        console.log(res)
        setLoginError(check);
        if (isEmpty(res)) {
          setErrorMessage("");
        } else if (res?.status === 401) {
          setErrorMessage("Μη έγκυρο email ή κωδικός, παρακαλώ προσπαθήστε ξανά.");
        }
        else {
          setErrorMessage(getLocalString(locales, res?.error));
        }
      })
    );
  };

  const handleSubmit = async e => {
    e.preventDefault();
    logingcall();
  };

  return (
    <div className="login-page" style={{ marginTop: '50px' }}>
      {/* {isLoadingLocales ? ( // Display spinner while locales are loading
        <Spin size="large" />
      ) : (
        <> */}
          <Row className="page-title-row login-title-row">
            <Col span={24} className="page-title-col login-title-col">
              <Label
                label={getLocalString(
                  locales,
                  localNames.LOGIN_PAGE_APPLICATIONLOGIN
                )}
                customClass="login-main-title"
              />

              <p style={{ textAlign: 'justify' }}>
                Για την υποβολή και την παρακολούθηση της πορείας της αίτησής
                σας στο Πρόγραμμα <strong>"SB Growth"</strong> εισέλθετε στην εφαρμογή
                χρησιμοποιώντας τους προσωπικούς κωδικούς που έχετε στο
                Taxisnet.
                <p style={{ textAlign: 'justify' }}>
                Συνεχίζοντας, επιβεβαιώνετε ότι έχετε διαβάσει και συμφωνείτε με
                την{' '}
                <a style={{ textDecoration: 'underline !important' }}
                  href={Πολιτική_Απορρήτου}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Πολιτική Απορρήτου
                </a>
                {' '}και την{' '}
                <a style={{ textDecoration: 'underline !important' }}
                  href={Πολιτική_Cookies}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Πολιτική Cookies
                </a>
                .
              </p>
              </p>
            </Col>
          </Row>

          <Row className="error-wrapper-row">
            <Col span={24} className="error-wrapper-col">
              {hasError && (
                <Alert
                  message="Σφάλμα"
                  description={message}
                  className="error-component"
                  type="error"
                  icon={<ExclamationCircleFilled />}
                  closable
                  showIcon
                />
              )}
              {hasInfo && (
                <Alert
                  description={message}
                  className="info-component"
                  type="info"
                  icon={<ExclamationCircleFilled />}
                  closable
                  showIcon
                />
              )}
            </Col>
          </Row>

          {process.env.REACT_APP_LOGIN_TO_PLATFORM_TAXIS === 'true' && gsisAuthUrl && (
            <Row className="oauth2-provider-row">
              <Col xs={24} sm={12} className="oauth2-provider-col">
                <Button
                  id='taxis-button'
                  type="primary"
                  className="oauth2-provider-submit"
                  disabled={loading}
                  onClick={authProviderSubmitClicked}
                >
                  {getLocalString(locales, localNames.LOGIN_PAGE_TAXISLOGIN)}
                </Button>
              </Col>
            </Row>
          )}

          <FormSwitcher id="form-control" />

          <Row className="form-title-row">
            <Col xs={24} sm={12} className="form-title-col">
              <FormTitle
                id="inputExpand"
                label={getLocalString(
                  locales,
                  localNames.LOGIN_PAGE_ADMINISTRATORLOGIN
                )}
                labelClassName="form-title"
                forComponent="form-control"

              />
            </Col>
          </Row>

          <div className="form-login-wrapper">
            <Row className="userpass-wrapper-row">
              <Col xs={24} sm={12} className="userpass-wrapper-col">
                <div className="form-group">
                  <label className="login-field-label">
                    {getLocalString(locales, localNames.LOGIN_PAGE_TITLE)}
                  </label>
                  <TextField
                    className="username-component"
                    containerClassName="username-container"
                    fieldName="username"
                    fieldType="text"
                    size="large"
                    id="inputUsername"
                    placeholder={getLocalString(
                      locales,
                      localNames.LOGIN_PAGE_ENTERUSERNAME
                    )}
                    disabled={loading}
                    customRef={inputRef}
                    onPressEnter={handleSubmit}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group" style={{ marginTop: '10px' }}>
                  <label id="labelPassword" className="login-field-label">
                    {getLocalString(
                      locales,
                      localNames.LOGIN_PAGE_PASSWORDREQUEST
                    )}
                  </label>
                  <Input
                    id="inputPassword"
                    className={loginError ? 'error' : ''}
                    containerClassName="password-container"
                    size="large"
                    type="password"
                    placeholder={getLocalString(
                      locales,
                      localNames.LOGIN_PAGE_ENTERPASSWORD
                    )}
                    onChange={e => setPassword(e.target.value)}
                    onPressEnter={handleSubmit}
                    value={password}
                    autoComplete="new-password"
                    style={{
                      // marginTop: '10px',
                      maxwidth: '100%',
                    }}
                  />
                  {loginError && errorMessage && (
                    <p style={{ color: 'red', fontSize: '12px' }}>
                      {errorMessage}
                    </p>
                  )}
                </div>
              </Col>
            </Row>

            <Row className="links-wrapper-row">
              <Col xs={12} sm={6} className="back-to-entrance-wrapper-col">
                <Link to="/" className="back-to-entrance-component">
                  {/* Πίσω στην είσοδο  */}
                  {getLocalString(
                    locales,
                    localNames.FORGOTPASSWORD_PAGE_BACK
                  )}
                </Link>
              </Col>
              <Col xs={12} sm={6} className="forgotpass-wrapper-col">
                <Link 
                to="/forgot-password" 
                className="forgotpass-component"
                id="inputForgotPassword"
                >
                  {getLocalString(
                    locales,
                    localNames.LOGIN_PAGE_FORGOTPASSBUTTON
                  )}
                </Link>
              </Col>
            </Row>

            <Row className="remember-wrapper-row">
              <Col xs={24} sm={12} className="remember-wrapper-col">
                <Checkbox
                  className="remember-component"
                  checked={rememberMe}
                  onChange={onRememberMeChange}
                  labelClassName="remember-label"
                  id="inputRememberMe"
                >
                  <div className='remember-text'>
                    {getLocalString(
                      locales,
                      localNames.LOGIN_PAGE_REMEMBERBUTTON
                    )}
                  </div>
                </Checkbox>
              </Col>
            </Row>

            <Row className="buttons-wrapper-row">
              <Col xs={24} sm={12} className="buttons-wrapper-col">
                <Button
                  type="primary"
                  className="submit-component"
                  disabled={loading}
                  onClick={handleSubmit}
                  id="inputEnter"
                >
                  {getLocalString(locales, localNames.LOGIN_PAGE_ENTER)}
                </Button>
              </Col>
            </Row>
          </div>
        {/* </>
      )}*/}
    </div> 
  );
};

export default Login;
